import React, { useState, useEffect } from 'react'
import { getUsersToConfig } from '@auteco/services/snopServices'
import { DialogAddEvent } from '../DetailsPage/components/DialogAddEvent/DialogAddEvent'

import './ButtonEventsSync.css'

const ButtonEventsSync = ({filter, handleFilterEventsSaved}) => {
  const [users, setUsers] = useState()
  const [openDialog, setOpenDialog] = useState(false)

  const onCloseDialog = () => {
    console.log(handleFilterEventsSaved(), "h")
    handleFilterEventsSaved()
    setUsers(null)
    setOpenDialog(false)
    getUsers()
  }

  const getUsers = async () => {
    const { usuarios } = await getUsersToConfig()
    if (usuarios) {
      setUsers(usuarios)
    }
  }

  const onAddEventGroup = () => {
    setOpenDialog(true)
  }

  useEffect(() => {
    getUsers()
  }, [])

  return (
    <>
      {users && (
        <DialogAddEvent
          users={users}
          groupId={0}
          edit={false}
          item={null}
          material={null}
          onGetEvents={() => {}}
          open={openDialog}
          onClose={() => onCloseDialog()}
          getconsolidadoInfo={() => {}}
          filter={filter}
        />
      )}
      <button className='button_ev' onClick={onAddEventGroup}> Agregar evento </button>
    </>
  )
}

export default ButtonEventsSync
